import styled from 'styled-components';
import {
  Checkbox as SemanticCheckbox,
} from 'semantic-ui-react';

import {
  Text as TextLayoutComponent,
  Header as HeaderLayoutComponent,
} from '@playbookux/playbook-web-core';

export const Header = styled(HeaderLayoutComponent)`
  margin-bottom: 4px;
  color: #000;
`;

export const ConditionContainer = styled.div`
  margin-bottom: 15px;
`;

export const FormRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;

  & > .field {
    flex: 0.5;
    margin-right: 15px;
  }
`;

export const Checkbox = styled(SemanticCheckbox)`
  margin-left: 15px;
  flex: 1;
`;

export const ErrorMessage = styled(TextLayoutComponent.Error)`
  text-align: left;
  margin-top: 10px;
  margin-bottom: 10px;
`;
